import { getChatHistoryApi, getChatListApi, getChatUnreadCountApi, sendMessageApi } from "@/api/chatApi";
import { ChatHistoryResponseType, ChatPreviewType } from "@/common/types";
import { setLoader } from "@/redux/actions/commonActions";
import Types from "@/redux/types";

export const getChatList = (page: number = 1) => async (dispatch: any) => {
  dispatch(setLoader(true));
  try {
    const result = await getChatListApi(page);
    if (result) {
      dispatch({
        type: Types.SET_CHAT_LIST,
        payload: result.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const getMoreChatList = (page: number = 1) => async (dispatch: any) => {
  dispatch(setLoader(true));
  try {
    const result = await getChatListApi(page);
    if (result) {
      dispatch({
        type: Types.SET_MORE_CHAT_LIST,
        payload: result.data,
      });
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

const extractPageNumber = (url: string) => () => {
  const parsedUrl = new URL(url);
  const page = parsedUrl.searchParams.get('page'); // Get the 'page' query parameter
  return page ? parseInt(page, 10) : null; // Convert to integer if exists
}

const fetchChatHistory = (id: number, pageNumber: number | null, chatHistory: ChatPreviewType[]) => async (dispatch: any) => {
  try {
    const result = await getChatHistoryApi(id, pageNumber);
    if (result) {
      if ((result.data as ChatHistoryResponseType)?.results.length > 0) {
        chatHistory.push(...(result.data as ChatHistoryResponseType)?.results)
      }
    }
    if (result.data.next) {
      const page = dispatch(extractPageNumber(result.data.next));
      if (page !== null) {
        await dispatch(fetchChatHistory(id, page, chatHistory));
      }
    }
  } catch (error) {
    console.log(error);
  }
}

export const getChatHistory = (id: number) => async (dispatch: any) => {
  const chatHistory: ChatPreviewType[] = []
  dispatch(setLoader(true));
  try {
    await dispatch(fetchChatHistory(id, 1, chatHistory));
    dispatch({
      type: Types.SET_CHAT_HISTORY,
      payload: chatHistory,
    });
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const clearChatList = () => async (dispatch: any) => {
  try {
    dispatch({
      type: Types.CLEAR_CHAT_LIST,
    })
    dispatch({
      type: Types.CLEAR_CHAT_HISTORY,
    })
  } catch (error) {
    console.log(error);
  }
}

export const sendMessage = (id: number, payload: any, callback: () => void) => async (dispatch: any) => {
  dispatch(setLoader(true));
  try {
    const result = await sendMessageApi(id, payload);
    if (result) {
      dispatch(getChatList());
      dispatch(getChatHistory(id));
    }
    callback();
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const getChatUnreadCount = () => async (dispatch: any) => {
  try {
    const result = await getChatUnreadCountApi();
    if (result) {
      dispatch({
        type: Types.SET_CHAT_UNREAD_COUNT,
        payload: result.data.unread_chats,
      });
    }
  } catch (error) {
    console.log(error);
  }
};
